module.exports = __webpack_public_path__ + "static/media/sell_report_deal_4.41b80426.png";